import {HttpUtils} from "./common/HttpUtils";
export class AcesService {

    constructor(auth) {
        this._auth = auth;
        this._headers = HttpUtils.getHttpHeaders(auth, 'text/json');
        this._baseUrl = `${process.env.VUE_APP_API_URL}/v1/catalog`;
    }

    /**
     * Uploads an ACES XML file to the system.  This defines all of the parts in the parts catalog.
     * The system is expected to immediately use the uploaded file as the source for the parts catalog.
     * @param {any} file ACES XML file
     * @returns an AcesLoadResponse containing information about the loading process.
     */
    uploadAces(file) {
        let url = `${this._baseUrl}/update`;
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('file', file);
            HttpUtils.post(url, this._auth, formData)
                .then((result) => { resolve(result) })
                .catch((ex) => {
                    console.error('[d835967] error adding image');
                    if (ex != null) {
                        console.log(ex);
                    }
                    reject(ex)
                });
        });
    }

}